module.exports = __webpack_public_path__ + "static/media/bronze.a911b447.svg";